export const PERMISSIONS = {
  CHAT_TRANSFER: 'CHAT_TRANSFER',
  AGENT_DASHBOARD: 'AGENT_DASHBOARD',
  ADMIN_DASHBOARD: 'ADMIN_DASHBOARD',
  TICKET_ASSIGN: 'TICKET_ASSIGN',
  ARTICLE_CREATE: 'ARTICLE_CREATE',
  ARTICLE_CREATE_ALL: 'ARTICLE_CREATE_ALL',
  ARTICLE_UPDATE_OWN: 'ARTICLE_UPDATE_OWN',
  ARTICLE_UPDATE_ALL: 'ARTICLE_UPDATE_ALL',
  ARTICLE_DELETE: 'ARTICLE_DELETE',
  TEAM_SETUP: 'TEAM_SETUP',
  REPORT_TRANSACTION: 'REPORT_TRANSACTION',
  REPORT_WALLET_TRANSACTION: 'REPORT_WALLET_TRANSACTION',
  REPORT_USER: 'REPORT_USER',
  CALL_CAMPAIGN_VIEW: 'CALL_CAMPAIGN_VIEW',
  CALL_CAMPAIGN_CREATE: 'CALL_CAMPAIGN_CREATE',
  CALL_CAMPAIGN_EXECUTE: 'CALL_CAMPAIGN_EXECUTE',
  CALL_CAMPAIGN_DELETE: 'CALL_CAMPAIGN_DELETE',
  CALL_CAMPAIGN_IMPORT: 'CALL_CAMPAIGN_IMPORT',
  CALL_CAMPAIGN_REPORTS: 'CALL_CAMPAIGN_REPORTS',
  ANY: 'ANY',
} as const

export type PermissionCode =
  (typeof PERMISSIONS)[keyof typeof PERMISSIONS] | (string & {})

export const ARTICLE_PERMISSION_CODES = [
  PERMISSIONS.ARTICLE_CREATE,
  PERMISSIONS.ARTICLE_UPDATE_OWN,
  PERMISSIONS.ARTICLE_UPDATE_ALL,
  PERMISSIONS.ARTICLE_DELETE,
] as const

export type ArticlePermissionCode =
  (typeof ARTICLE_PERMISSION_CODES)[number] | (string & {})

export const ARTICLE_PERMISSION_GUARDS = [
  ...ARTICLE_PERMISSION_CODES,
  PERMISSIONS.ANY,
] as const
